export const ACCESS_TOKEN_EXPIRATION_TIME_MIN = 60
export const REFRESH_TOKEN_EXPIRATION_TIME_MIN = 60 * 24 * 30
export const GOOGLE_ACCESS_TOKEN_EXPIRATION_TIME_MIN = 60
